import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: { minWidth: theme.spacing(20) },
  };
};
